export default {
  default: 2,
  large: 4,
  round: 9999,
  ellipse: '100%'
};